<template>
  <div v-if="stats !== null">
    <h2
      class="flex-fJstart-fAcenter"
      @click="toggle"
    >
      Tableau de données
      <span
        :class="(showContenu)?'ui-icon ui-icon-carat-1-n':'ui-icon ui-icon-carat-1-s'"
        title="toggle"
      />
    </h2>

    <div v-if="showContenu">
      <table class="adminStatsTable">
        <thead>
          <tr>
            <th />
            <th>
              Connexions
            </th>
            <th>
              Commandes
            </th>
            <th>
              Chiffres d'affaire HT
            </th>
            <th>
              Panier moyen
            </th>
            <th>
              Nombre de premières connexions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="intervalle of statsPage"
            :key="intervalle.code"
          >
            <td>{{ intervalle.libelle }}</td>
            <td>{{ (intervalle.connexions).toLocaleString() }}</td>
            <td>{{ (intervalle.commandes).toLocaleString() }}</td>
            <td>{{ (Math.round(intervalle.ca*100)/100).toLocaleString() }} €</td>
            <td>{{ (Math.round(intervalle.camoyen*100)/100).toLocaleString() }} €</td>
            <td>{{ (intervalle.premiereco).toLocaleString() }}</td>
          </tr>
          <tr v-if="arrayStats.length === 0">
            <td colspan="4">Aucune donnée à afficher</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="arrayStats.length"
        :current="currentPage"
        :pages="pagesNumber"
        @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '../../Pagination'

export default {
  components: { Pagination },
  data: function() {
    return {
      pageSize: 15,
      currentPage: 1,
      statsPage: [],
      showContenu: true
    }
  },
  computed: {
    ...mapGetters([
      'stats'
    ]),
    arrayStats: function() {
      return (this.stats !== null) ? Object.values(this.stats).reverse() : []
    },
    pagesNumber: function() {
      return Math.ceil(this.arrayStats.length / this.pageSize)
    }
  },
  methods: {
    changePage: function (page) {
      this.currentPage = page
      let start = (this.currentPage - 1) * this.pageSize
      this.statsPage = this.arrayStats.slice(start, start+this.pageSize)
    },
    toggle: function () {
      this.showContenu = !this.showContenu
    }
  },
  watch: {
    arrayStats: function() {
      this.changePage(1)
    }
  }
}
</script>
